import { render, staticRenderFns } from "./distributioncontrol.vue?vue&type=template&id=b8bbf020&"
import script from "./distributioncontrol.vue?vue&type=script&lang=js&"
export * from "./distributioncontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports